/**
 * Navigation Reference Utility
 *
 * Provides a way to navigate from outside React components (e.g., App.tsx).
 * Uses React Navigation's createNavigationContainerRef.
 */

import { createNavigationContainerRef } from '@react-navigation/native';
import { RootStackParamList } from '../types';

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

/**
 * Navigate to a screen from outside a React component
 * Only works after the NavigationContainer has mounted
 *
 * For screens without params, call as: navigate('Home')
 * For screens with params, call as: navigate('Chat', { conversationId: '123' })
 */
export function navigate<RouteName extends keyof RootStackParamList>(
  ...args: undefined extends RootStackParamList[RouteName]
    ? [screen: RouteName] | [screen: RouteName, params: RootStackParamList[RouteName]]
    : [screen: RouteName, params: RootStackParamList[RouteName]]
): void {
  if (navigationRef.isReady()) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Cast needed: React Navigation's navigate has complex overloads that don't match our conditional type
    (navigationRef.navigate as any)(...args);
  } else {
    console.warn('[Navigation] Attempted to navigate before NavigationContainer mounted:', args[0]);
  }
}
